import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { admin, basic, t1aAdmin } from "../common/options/adminOptions";
import { IUseUpdatePasswordFromValue, ReferalRegisterSignupForm, RefferalSignUpFormValues, RegisterSignupForm, User, UserLoginFormValues } from "../models/user";
import { router } from "../router/Routes";
import { store } from "./store";
import { toast } from "react-toastify";

export default class UserStore {
  user: User | null = null;
  refreshTokenTimeout: any;
  loading = false;
  isResetPassword = false;

  isPasswordChangeSuccess = true;

  constructor() {
    makeAutoObservable(this);
  }

  get isLoggedIn() {
    return !!this.user;
  }
  login = async (creds: UserLoginFormValues) => {
    window.localStorage.removeItem('userrole');
    try {
      let user = await agent.Account.login(creds);
      if (user.roles.length > 0) {
        user.roles.forEach(r => {
          r.routeId = '/'
        })
        if (store.commonStore.currentUserRole === null && user.roles.some(x => x.role)) {
          store.commonStore.setCurrentUserRole(user.roles[0].role)
        }
        if (store.commonStore.currentUserRole !== null && !user.roles.some(x => x.role === store.commonStore.currentUserRole)) {
          store.commonStore.setCurrentUserRole(user.roles[0].role)
        }
      }


      store.commonStore.setToken(user.token);
      this.startRefreshTokenTimer(user);
      runInAction(() => (this.user = user));
      store.modalStore.closeModal();
      router.navigate(user && '/');
    } catch (error) {
      toast.error('Please check Username or password')
      throw error;
    }
  };

  logout = (home: boolean = true) => {
    store.commonStore.setToken(null);
    window.localStorage.removeItem("userJwt");
    window.localStorage.removeItem('userrole');
    this.user = null;
    store.playerProfileStore.resetProfile();
    store.adminStore.resetAdminStore();
    store.appDataStore.resetAppDataStore();
    store.basicUserStore.resetBasicUserStore();
    if (home) {
      router.navigate("/");
    }
  };

  getUser = async () => {
    try {
      let user = await agent.Account.current();
      if (user.roles?.length > 0) {
        user.roles.forEach(r => {
          r.routeId = '/'
        })
        if (store.commonStore.currentUserRole === null && user.roles.some(x => x.role)) {
          store.commonStore.setCurrentUserRole(user.roles[0].role)
        }
        if (store.commonStore.currentUserRole !== null && !user.roles.some(x => x.role === store.commonStore.currentUserRole)) {
          store.commonStore.setCurrentUserRole(user.roles[0].role)
        }
      }
      store.commonStore.setToken(user.token);
      runInAction(() => this.user = user);
      this.startRefreshTokenTimer(user);
    } catch (error) {
      console.log(error);
    }
  }

  changeUserRole = async (newRole: string) => {
    try {

      let newUserRole = await agent.Account.changeUserRole(newRole);

      if (newUserRole) {
        // user.roles.forEach(r => {
        //   r.routeId = '/'
        // })
        store.commonStore.setCurrentUserRole(newUserRole)
        //Reset side effects
        store.reportingStore.resetStoreData();
      }

      runInAction(() => {
        let user = this.user;
        if (user) {
          user.currentUserRole = newUserRole;
          this.user = user;
        }
      });

    } catch (error) {
      console.log(error);
    }
  }

  getUserRole = () => {
    let role = basic;
    if (this.user && this.user.currentUserRole) {
      role = this.user.currentUserRole;
    }
    return role;
  }

  get isAdmin() {
    return (this.isLoggedIn && this.user?.currentUserRole === admin);
  }

  get isT1aAdmin() {
    return (this.isLoggedIn && this.user?.currentUserRole === t1aAdmin)
  }

  register = async (creds: RefferalSignUpFormValues) => {
    this.loading = true;
    try {
      await agent.Account.register(creds);
      router.navigate(`/newUser/registerSuccess?email=${creds.email}&displayName=${creds.fullName}`);
      store.commonStore.setToken(null);
      window.localStorage.removeItem("userJwt");
      this.user = null;
      store.playerProfileStore.resetProfile();
    } catch (error) {
      throw error;
    }
    this.loading = false;
  };

  addNewRegisterReferal = async (creds: ReferalRegisterSignupForm) => {
    this.loading = true;
    try {
      await agent.Account.addNewSignUpregisterReferal(creds);
      router.navigate(`/newUser/registerSuccess?email=${creds.email}`);
      store.commonStore.resetAppData();
      store.commonStore.setToken(null);
      window.localStorage.removeItem("userJwt");
      this.user = null;
      store.playerProfileStore.resetProfile();
    } catch (error) {
      throw error;
    }
    this.loading = false;
  };

  addNewRegisteration = async (values: RegisterSignupForm) => {
    this.loading = true;
    try {
      await agent.Account.addNewRegisteration(values);
      store.commonStore.resetAppData();
      store.commonStore.setToken(null);
      window.localStorage.removeItem("userJwt");
      this.user = null;
      store.playerProfileStore.resetProfile();
      runInAction(() => this.loading = false)
      router.navigate('/successsignup');
    } catch (error) {
      runInAction(() => this.loading = false)
      throw error;
    }
  };

  setDisplayName = (name: string) => {
    if (this.user) this.user.username = name;
  };

  refreshToken = async () => {
    this.stopRefreshTokenTimer();
    try {
      const user = await agent.Account.refreshToken();
      if (user.roles.length > 0) {
        user.roles.forEach(r => {
          r.routeId = '/'
        })
        if (store.commonStore.currentUserRole === null && user.roles.some(x => x.role)) {
          store.commonStore.setCurrentUserRole(user.roles[0].role)
        }
        if (store.commonStore.currentUserRole !== null && !user.roles.some(x => x.role === store.commonStore.currentUserRole)) {
          store.commonStore.setCurrentUserRole(user.roles[0].role)
        }
      }

      runInAction(() => this.user = user);
      store.commonStore.setToken(user.token);
      this.startRefreshTokenTimer(user);
    } catch (error) {
      console.log(error);
    }
  }

  private startRefreshTokenTimer(user: User) {
    const jwtToken = JSON.parse(atob(user.token.split('.')[1]));
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    this.refreshTokenTimeout = setTimeout(this.refreshToken, timeout);
  }

  private stopRefreshTokenTimer() {
    runInAction(() => clearTimeout(this.refreshTokenTimeout))
  }

  resetPassword = async (
    token: string,
    email: string,
    password: string,
    confirmPassword: string
  ) => {
    this.isResetPassword = false;
    try {
      await agent.Account.resetPassword(
        token,
        email,
        password,
        confirmPassword
      );
      runInAction(() => {
        this.isResetPassword = true;
        router.navigate("/userPasswordReset/resetValidate");
      });
    } catch (error) {
      runInAction(() => {
        this.isResetPassword = false;
        router.navigate("/userPasswordReset/resetValidate");
      });
      console.log(error);
    }
  };

  changeUserPassword = async (
    updatedPassword: IUseUpdatePasswordFromValue
  ) => {
    this.loading = true;
    this.isPasswordChangeSuccess = true;
    try {
      await agent.Account.changePassword(updatedPassword);
      runInAction(() => {
        this.loading = false;
        this.isPasswordChangeSuccess = true;
        toast.success("The password has been changed successfully");
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
        this.isPasswordChangeSuccess = false;
        throw error;
      });
    }
  };
}
